import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

import { firebaseConfig } from "./firebaseConfig";

export const app = initializeApp(firebaseConfig);
export const analytics = () => getAnalytics(app);
export const auth = getAuth(app);
